export default __webpack_public_path__ + "static/search_term-8ebe8047957d7a2426a942d89edaba7d.svg";